import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { useLandingAuthCta } from "../hooks/useLandingAuthCta";

export function FooterCta() {
  const { t } = useTranslation("landing");
  const cta = useLandingAuthCta();

  return (
    <section className="relative isolate overflow-hidden border-t border-[#1B2622] bg-[#080C0D]">
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            "radial-gradient(620px 360px at 50% 120%, rgba(76, 214, 196,0.16), transparent 70%)",
        }}
      />
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 opacity-60"
        style={{
          backgroundImage:
            "linear-gradient(rgba(76, 214, 196,0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(76, 214, 196,0.05) 1px, transparent 1px)",
          backgroundSize: "44px 44px",
          maskImage:
            "radial-gradient(ellipse 80% 100% at 50% 100%, #000 30%, transparent 75%)",
        }}
      />

      <div className="relative mx-auto max-w-[1320px] px-6 py-24 text-center lg:px-10 lg:py-32">
        <div className="mx-auto mb-8 flex items-center justify-center gap-3">
          <span className="bp-dot" aria-hidden />
          <span className="mono-label">Ready to deploy</span>
        </div>

        <h2 className="bp-display mx-auto max-w-[16ch] text-[40px] leading-[1.04] text-[#E2EDE7] sm:text-[64px] lg:text-[88px]">
          {t("footerCta.title")}
        </h2>

        <p className="mx-auto mt-7 max-w-[44ch] text-[15px] leading-[1.7] text-[#8A9990]">
          {t("footerCta.subtitle")}
        </p>

        <div className="mt-10 flex justify-center">
          <Link
            to={cta.primary.href}
            className="bp-btn group inline-flex h-14 items-center gap-3 px-9 text-[14px]"
          >
            {cta.isAuthenticated ? t("nav.dashboard") : t("footerCta.button")}
            <span className="transition-transform group-hover:translate-x-1">→</span>
          </Link>
        </div>
      </div>
    </section>
  );
}

export default FooterCta;
